module.exports = __webpack_public_path__ + "img/visual-analysis.18b38e2b.webp";